import { Showcase } from "../../components/Showcase";
import {
  getInsuranceAdvisorData,
  InsuranceAdvisorProvider,
} from "../../contexts";
import { getPropsByName } from "../../utils";
import type { PageProps, WithMetadata } from "../Page";
import { Page, PageProviders } from "../Page";
import type { ShowcasePageProps, ShowcaseProps } from "./types";

export const ShowcasePage = (props: ShowcasePageProps) => {
  const showcaseProps = getPropsByName({
    name: "showcase",
    components: props.layout.components,
  }) as WithMetadata<ShowcaseProps>;

  const insuranceAdvisorData = getInsuranceAdvisorData(props as PageProps);

  return (
    <PageProviders {...(props as PageProps)}>
      <InsuranceAdvisorProvider insuranceAdvisorData={insuranceAdvisorData}>
        <Page {...(props as PageProps)}>
          <main className="mobius mobius-page__main">
            {showcaseProps && <Showcase {...showcaseProps} />}
          </main>
        </Page>
      </InsuranceAdvisorProvider>
    </PageProviders>
  );
};
